// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { CrehanaTFunction, useTranslation } from '@crehana/i18n';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Checkbox } from '@crehana/ui';
import { clsx } from 'clsx';

// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { LegalCheckboxProps } from './types';

export const rulesForRHFControllerComponent = (t: CrehanaTFunction) => ({
  required: {
    value: true,
    message: t(
      'AUTH_VALIDATION_LEGALS_REQUIRED',
      'Debes aceptar los Términos, Condiciones y Políticas para continuar.',
    ),
  },
});

export const LegalErrorMessage: React.FC<
  React.PropsWithChildren<{ message?: string }>
> = ({ message }) => (
  <span className="block mt-4 font-legals text-red-main" role="alert">
    {message}
  </span>
);

export const LegalCheckbox: React.FC<
  React.PropsWithChildren<LegalCheckboxProps>
> = ({
  onChange,
  value,
  darkMode,
  dataTestId,
  textClassName,
  linkClassName,
}) => {
  const { t } = useTranslation();

  return (
    <Checkbox
      small
      darkMode={darkMode}
      data-testid={dataTestId}
      label={
        <>
          <span className={textClassName}>
            {t('LEGALS_TEXT_1', 'Acepto los ')}
          </span>
          <a
            href="/legal/"
            target="_blank"
            className={clsx('font-legals', linkClassName)}
            style={{
              textDecoration: 'none',
            }}
          >
            {t(
              'LEGALS_TEXT_2',
              'Términos, Condiciones y Políticas de Crehana.',
            )}
          </a>
        </>
      }
      onChange={event => {
        const { checked } = event.target;

        onChange(!checked);
      }}
      checked={value}
    />
  );
};

export default LegalCheckbox;
